/* eslint-disable */
import '@/js/desktop/plugins/stickyKit';

let FixFiltersPositionView = Backbone.View.extend({
	scrollToTop: function () {
		if ($(document).scrollTop() > 0) {
			$("html,body").stop(true, false).animate({scrollTop: 0}, 700);
		}
	},
	initFiltersPosition: function () {
		var self = this,
			$mainColumnLeft = $(".mainColumnLeft"),
			$mainColumnRight = $(".mainColumnRight"),
			toTopHeight = $mainColumnLeft.offset().top,
			scrollTop = this.scrollToTop,
			topFilterPosition = 0,
			selectorArray = [".filtersList.hotelCategory", ".filtersList.meal",".formControl.selectHotel"],
			stachPosition = null;

		$(window).on("scroll", function () {
			var heightMainColumnLeft = $mainColumnLeft.outerHeight(true);
			topFilterPosition = ($(".searchFormFliedContainer.fixedTop").outerHeight(true) || 0);
			// проверка
			if (
					//положение скролла
					$(this).scrollTop() > (heightMainColumnLeft + toTopHeight - topFilterPosition)
				&&
					//скролл относительно выдачи
					heightMainColumnLeft < $mainColumnRight.outerHeight(true)
				&&
					// штрина окна больше
					$(window).width() >= 1240

					//есть ли выдача и
				&& ((self.searchPageModel.get('filteredHotels') && self.searchPageModel.get('filteredHotels').length) || self.searchPageModel.get('beforeToursLoading'))
				&& !$mainColumnLeft.hasClass("fixedFilters"))
			{
				stachPosition = heightMainColumnLeft + toTopHeight - topFilterPosition;
				// отступ сверху в зависимости от
				$mainColumnLeft.addClass("fixedFilters");
				addFilterBlockShowAllButton(selectorArray);
				$mainColumnLeft.stick_in_parent({
					"offset_top": topFilterPosition + 15
				});

			} else if(
				!($(this).scrollTop() > stachPosition) &&
				$mainColumnLeft.hasClass('fixedFilters')) {

				removeFixedFiltersElement(selectorArray);
				$mainColumnLeft.trigger("sticky_kit:detach");

			}
		});


		function addFilterBlockShowAllButton(selectorArray) {
			var $element,
				$filtersList,
				filtersListHeight;
			for (var i in selectorArray) {
				$element = $mainColumnLeft.find(selectorArray[i]).parent();
				$filtersList = $element.find("ul");
				filtersListHeight = $filtersList.outerHeight(true);
				$element.addClass("minFilter").children('ul').after(
					$("<a>", {
						href: "",
						class: "primary-link js-sow-all-filters-component",
						click: function (e) {
							e.preventDefault();
							$(this).siblings('.filtersList').toggleClass("filter-open");
							$mainColumnLeft.trigger("sticky_kit:recalc");
						}
					})
				);
			}

			$mainColumnLeft.append($("<div>", {
				class: "show-all-filters filters",
				html: $("<a>", {
					href: "",
					text: "Полный список фильтров",
					click: function (e) {
						e.preventDefault();
						scrollTop();
						$(this).parent().remove();
					}
				})
			}));
		}

		function removeFixedFiltersElement(selectorArray) {
			for (var i in selectorArray) {
				$(selectorArray[i], $mainColumnLeft)
					.removeClass('filter-open')
					.removeClass("minFilter")
					.parent().find(".js-sow-all-filters-component").remove();
			}
			$mainColumnLeft.removeClass("fixedFilters").find(".show-all-filters").detach();
		}
	},
	initialize: function (options) {
		this.searchPageModel = options.searchPageModel;
		this.initFiltersPosition();
	}
});

export default FixFiltersPositionView;
